import React from "react";

/**
 * Render one of the core `icons.tsx` SVG elements inline in the app's share
 * surfaces (ShareControl / SharePopover / EmbedInNotion), sized to the
 * surrounding text (~1em) and inheriting its colour via `currentColor` — which
 * the core icons already use. The core icon set is authored as pre-built
 * `<svg>` elements with no width/height attribute, so we clone the element and
 * apply a size rather than editing `icons.tsx`.
 */
export const glyph = (
  icon: JSX.Element,
  size: string | number = "1em",
): JSX.Element =>
  React.cloneElement(icon, {
    style: {
      width: size,
      height: size,
      display: "inline-block",
      flexShrink: 0,
      ...(icon.props.style as React.CSSProperties | undefined),
    },
  });
